export class GenericManufacturerSimulationGlobalInformation {
  id!: number;
  pharmacyRefId!: number;
  laboratoryId!: number;
  laboratoryName?: string;
  month?: number;
  year?: number;
  calculationName?: string;
  calculationResult?: string;

  static fromBackend(data: any): GenericManufacturerSimulationGlobalInformation {
    return {
      id: data.id,
      pharmacyRefId: data.idOfficineRef,
      laboratoryId: data.idLaboratoire,
      laboratoryName: data.nomLabo,
      month: data.mois,
      year: data.annee,
      calculationName: data.nomCalcul,
      calculationResult: data.valeurCalcul,
    } as GenericManufacturerSimulationGlobalInformation;
  }

  static fromBackendList(data: any[]): GenericManufacturerSimulationGlobalInformation[] {
    return data.map(item => GenericManufacturerSimulationGlobalInformation.fromBackend(item));
  }
}
